const getTitleExtraValue = (
    sectionExtra: Record<string, any> | null | undefined,
    key: string,
) => {
    if (!sectionExtra) return null

    return sectionExtra[`title[${key}]`] ?? null
}

const extractFontSizeByPrefix = (classNames: string, prefix: string) => {
    const token = classNames
        .split(' ')
        .find(currentClass => currentClass.startsWith(prefix))

    if (!token) return null

    const value = token.replace(prefix, '')

    return /^\d+$/.test(value) ? value : null
}

export const getTitleDefaultFontSizeClass = (
    sectionExtra: Record<string, any> | null | undefined,
    fallbackSectionExtra: Record<string, any> | null | undefined,
) => {
    return String(
        getTitleExtraValue(sectionExtra, 'font_size')
        || getTitleExtraValue(fallbackSectionExtra, 'font_size')
        || '',
    ).trim()
}

export const resolveResponsiveFontSizePx = (
    classNames: string,
    viewportWidth = typeof window !== 'undefined' ? window.innerWidth : 1024,
) => {
    const normalizedClassNames = String(classNames || '').trim()

    if (!normalizedClassNames) return null

    let resolvedValue = extractFontSizeByPrefix(normalizedClassNames, 'font-')

    if (viewportWidth >= 576) {
        resolvedValue = extractFontSizeByPrefix(normalizedClassNames, 'font-sm-') || resolvedValue
    }

    if (viewportWidth >= 768) {
        resolvedValue = extractFontSizeByPrefix(normalizedClassNames, 'font-md-') || resolvedValue
    }

    if (viewportWidth >= 992) {
        resolvedValue = extractFontSizeByPrefix(normalizedClassNames, 'font-lg-') || resolvedValue
    }

    if (viewportWidth >= 1200) {
        resolvedValue = extractFontSizeByPrefix(normalizedClassNames, 'font-xl-') || resolvedValue
    }

    return resolvedValue ? `${resolvedValue}px` : null
}

export const getTitleDefaultFontSizePx = (
    sectionExtra: Record<string, any> | null | undefined,
    fallbackSectionExtra: Record<string, any> | null | undefined,
    fallbackFontSize = '32px',
    viewportWidth = typeof window !== 'undefined' ? window.innerWidth : 1024,
) => {
    const classNames = getTitleDefaultFontSizeClass(sectionExtra, fallbackSectionExtra)
    const resolvedFontSize = resolveResponsiveFontSizePx(classNames, viewportWidth)

    return resolvedFontSize || fallbackFontSize
}

export const getTitleDefaultFontWeight = (
    sectionExtra: Record<string, any> | null | undefined,
    fallbackFontWeight = '700',
) => String(getTitleExtraValue(sectionExtra, 'font_weight') || fallbackFontWeight || '')

export const getTitleDefaultTextAlign = (
    sectionExtra: Record<string, any> | null | undefined,
    fallbackTextAlign = 'left',
) => String(getTitleExtraValue(sectionExtra, 'text_align') || fallbackTextAlign || 'left')
